import React, { Component } from 'react';
import {CreatePageChooseTmp} from './CreatePageChooseTmp.js';
import {CreatePageTelegramIntegration} from './CreatePageTelegramIntegration.js';
import Fade from './Fade.js';
import axios from 'axios';
import {CreatePageInputs} from './CreatePageInputs.js';
import {CreateWidgetNameChannel} from './CreateWidgetNameChannel';
import Cookies from 'universal-cookie'; 
import {CreateWidgetChooseSocialNetwork} from './CreateWidgetChooseSocialNetwork';
import { toHaveDisplayValue } from '@testing-library/jest-dom/dist/matchers';
import {TgWidgetImplementationPage} from './TgWidgetImplementationPage.js';
import { VkAuthPage } from './VkAuthPage.js';
import {TgbotTokenPage} from './TgbotTokenPage.js';
import {Loader} from './Loader.js';
import { LineProgressBar } from '@frogress/line';
import { HorizontalLine } from './HorizontalLine.js';
import LeftArrowIcon from './LeftArrowIcon';
import HelpBlockIcon from './HelpBlockIcon';



export class CreateWidget extends React.Component {

    
    state = {
        loading: false,
        showVkAuthPage : false,
        showPreview: false,
        chooseSocialNetworkPage : !false, //!
        showTgNameChannelPage : false,
        showFirstStage : false,
        showSecondStage : false,
        showThirdStage : false,
        showWidgetImplementionPage : false,
        showTgBotTokenPage : false,
        widget_name : '',
        channel_name: '',
        showErrorMsg : false,
        errorMsg : null,
        tmp_id : null,
        big_img_src : null,
        small_img_src : null,
        selected_file : null,
        prize : '',
        header_text : 'Пример заголовка',
        main_text : 'Пример основного текста',
        btnText : 'Подписаться',
        socialNetwork : 'vk',
        scriptsText : null,
        timeout: 7,
        bot_token: '',
        isLoading : false,
        stage : '25_vk',
        showProgressNum : true,
        infoBlock: '',
        successMsg : '',
        showSuccessMsg : false,
        stageNum: 4,
        progressBarHeight:  23,
        bg_mobile_opacity : 1,
        show_color_picker_bg_mobile_color : false,
        bg_mobile_color : 'white',
        bg_mobile_color_hex: 'white',
        frame_view_type: 'desktop',
        frame_height: 300,
        frame_width : 571,
        bg2_opacity : 1,
        bg2_color_hex: 'black',
        bg1_color_hex: 'yellow',
        bg1_opacity : 1,
        btn_color_hex : 'blue',
        h1_color : 'black',
        h1_color_hex: 'black',
        h2_color_hex: 'black',
        logo_color_hex: 'black',
        btn_text_color_hex: 'white',
        show_color_picker_btn_color : false,
        btn_color : 'blue',
        show_color_picker_bg1_color : false,
        bg1_color : 'blue',
        show_color_picker_bg2_color : false,
        bg2_color : 'blue',
        show_color_picker_btn_text_color : false,
        btn_text_color : 'white',
        show_color_picker_h1_color: false,
        show_color_picker_h2_color : false,
        h2_color : 'black',
        show_color_picker_logo_color : false,
        logo_color : 'green'
    }

    constructor(props) {
        super(props);
        this.doShowErrorMsg = this.doShowErrorMsg.bind(this)
        this.CheckIntegration = this.CheckIntegration.bind(this)
        this.ChooseTemplate = this.ChooseTemplate.bind(this)
        this.handleInputChange_smallImg = this.handleInputChange_smallImg.bind(this);
        this.handleInputChange_bigImg = this.handleInputChange_bigImg.bind(this);
        this.doSave = this.doSave.bind(this)
        this.updatePrize = this.updatePrize.bind(this)
        this.updateHeader = this.updateHeader.bind(this)
        this.updateMain = this.updateMain.bind(this)
        this.changeSocialNetwork = this.changeSocialNetwork.bind(this)
        this.ChooseSocialNetwork = this.ChooseSocialNetwork.bind(this)
        this.setShowPreview = this.setShowPreview.bind(this)
        this.updateWidgetNameVk = this.updateWidgetNameVk.bind(this)
        this.updateTimeout = this.updateTimeout.bind(this)
        this.updateBotToken = this.updateBotToken.bind(this)
        this.verifyBot = this.verifyBot.bind(this)
        this.goBack = this.goBack.bind(this)
        this.goFurther = this.goFurther.bind(this)
        this.ClearPhotoMobile = this.ClearPhotoMobile.bind(this)
        this.changeFrameView = this.changeFrameView.bind(this)
        this.showColorPicker = this.showColorPicker.bind(this)
        this.setDefault = this.setDefault.bind(this)
        this.handleClickOutside = this.handleClickOutside.bind(this)
        
        this.colorPickerBgMobileColorRef = React.createRef();
        this.refFirstStage = React.createRef();
        this.colorPickerBtnColorRef = React.createRef();
        this.colorPickerBg1ColorRef = React.createRef();
        this.colorPickerBg2ColorRef = React.createRef();
        this.colorPickerBtnTextColorRef = React.createRef();
        this.colorPickerH1ColorRef = React.createRef();
        this.colorPickerH2ColorRef =  React.createRef();
        this.colorPickerLogoColorRef =  React.createRef();


        const cookies = new Cookies();
        cookies.set('widgetNameVk', this.state.widget_name, {path : '/'})
    }

    
    setDefault() {
        this.setState({
            bg1_color : {r:7, g:103, b:244, a:0.04},
            bg1_color_hex: '#0767F4',
            bg1_opacity : 0.04,
            

            bg2_color : {r: 255, g: 255, b:255, a:1},
            bg2_color_hex: 'white',
            bg2_opacity : 1,
            

            bg_mobile_color : {r: 255, g: 255, b:255, a:1},
            bg_mobile_color_hex: 'white',
            bg_mobile_opacity : 1,

            btn_text_color : {r: 255, g: 255, b:255, a:1},
            btn_text_color_hex: 'white',
             

            btn_color : {r:7, g:103, b:244, a:0.04},
            btn_color_hex: '#0767F4',

            h1_color : {r: 0, g: 0, b:0},
            h1_color_hex: '#000000',
             

            h2_color : {r: 137, g: 137, b:137 , a:1},
            h2_color_hex: '#898989',
             

            logo_color : {r:7, g:103, b:244, a:0.04},
            logo_color_hex: '#0767F4',
        })
          
    }
    
    initialContent = () => {
        //286 571

        return (
          `<!DOCTYPE html>
          <html>
            <head>
              <link href="https://clientsaver.ru/static/css/main_with_viewport_v2.css" rel="stylesheet" />
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
            </head>
            <body>
              <div id="page" class="page"></div>
            </body>
          </html>`
        )
      }

    showColorPicker = ( a) => {
        
        //const decimalToHex = (alpha: number) => alpha === 0 ? '00' : Math.round(255 * alpha).toString(16)

        //const hexCode = `${color.hex}${decimalToHex(color.rgb.a)}` 
        
         
        if (a == 'btn') {
            this.setState({show_color_picker_btn_color: true})
        }
        if (a == 'bg1') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_bg1_color: true })
        }
        if (a == 'bg2') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_bg2_color: true })
        }
        
        if (a == 'btnText') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_btn_text_color: true })
        }
        if (a == 'h1') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_h1_color: true })
        }
        if (a == 'h2') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_h2_color: true })
        }
        if (a == 'logo') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_logo_color: true })
        }
        if (a == 'bgMobile') {
            
            this.setState({ show_color_picker_bg_mobile_color: true })
        }
       
      }

    getIframeSize(a) {
        //alert(window.innerWidth)
        if (window.innerWidth  >= 3500) {
            if (a == 'mobile') {
                return [1100, 618]
            }
            else {
                return [788, 1500]
            }
        }

        if (window.innerWidth  >= 3000) {
            if (a == 'mobile') {
                return [1100, 618]
            }
            else {
                return [688, 1300]
            }
        }

        if (window.innerWidth  >= 2500) {
            if (a == 'mobile') {
                return [900, 518]
            }
            else {
                return [618, 1100]
            }
        }


        if (window.innerWidth  >= 2200) {
            if (a == 'mobile') {
                return [900, 518]
            }
            else {
                return [518, 900]
            }
        }


        if (window.innerWidth  >= 1750) {
            if (a == 'mobile') {
                return [700, 398]
            }
            else {
                return [398, 700]
            }
        }

        if (window.innerWidth  >= 1245) {
            if (a == 'mobile') {
                return [571, 300]
            }
            else {
                return [300, 571]
            }
        }

        if (window.innerWidth  >= 1000) {
            if (a == 'mobile') {
                return [500, 300]
            }
            else {
                return [200, 360]
            }
        }
        if (a == 'mobile') {
            return [500, 300]
        }
        else {
            return [200, 360]
        }

      }

      changeFrameView(a) {
        var d = this.getIframeSize(a)
        
        this.setState({
            frame_view_type : a,
            frame_height: d[0],
            frame_width: d[1]
        })
      }

    componentDidMount() {
       
        

    }
    ClearPhotoMobile(e) {
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   small_img_src : null,
                   selectedFile : null
               
               };
       }, () =>  {
           
       })
    }
    handleInputChange_bigImg(event) {
        
        this.setState({
            selectedFile: event.target.files[0],
            isLoading: true
          }, () => {
            const data = new FormData() 
            data.append('file', this.state.selectedFile)
            console.warn(this.state.selectedFile);
            
            const cookies = new Cookies();
            
            axios.post(process.env.REACT_APP_BACKEND_SERVER + '/UploadImg/',
                 data, {
                    headers: {
                        'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                    } // receive two parameter endpoint url ,form data 
            })
            .then(res => { // then print response status
                 
                this.setState({
                    big_img_src: res.data.link,
                    isLoading: false
                  }, () => {})
            })
          })

    }

    setShowPreview(e, val) {
        e.preventDefault()
        //alert(1)
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   showPreview : val
                   
               
               };
       }, () =>  {
           
       })
    }

    handleInputChange_smallImg(event) {
        
        this.setState({
            selectedFile: event.target.files[0],
            isLoading: true
          }, () => {
            const data = new FormData() 
            data.append('file', this.state.selectedFile)
            console.warn(this.state.selectedFile);
            
            const cookies = new Cookies();
            axios.post(process.env.REACT_APP_BACKEND_SERVER + '/UploadImg/',
                 data, {
                    headers: {
                        'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                    }     // receive two parameter endpoint url ,form data 
            })
            .then(res => { // then print response status
                 
                this.setState({
                    small_img_src: res.data.link,
                    isLoading: false
                  }, () => {})
            })
          })

    }


    updatePageName = (e) => {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    widget_name : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    
    }

    updateChannelName = (e) => {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    channel_name : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    
    }
    
    

    CheckIntegration =(e) => {
        e.preventDefault()
        //alert('CheckIntegration')
        
        const cookies = new Cookies();
        this.setState({
            isLoading: true
        })
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/CheckChannelIntegrated', {
            headers: {
                'Authorization': 'Bearer '+cookies.get('tgsubs_token')
            },
            params : {
                'chat_id' : this.state.channel_name,
                'bot_token' : this.state.bot_token
            }
        }).then((res) => {
            console.log(res.data)
            this.setState({
                isLoading: false
            })
            if (res.data.is_integrated) {
                this.goFurther(e)
            }
            else {
                this.doShowErrorMsg('вы не настроили интеграцию')                                
           }
        })
        
    }

    ChooseTemplate = (e, tmp_id) => {
        

        
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   tmp_id : tmp_id,
                    
               };
       }, () =>  {
           
       })

       this.handleClickSecondStage(e)

    }

    doShowErrorMsg ( msg) {
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   errorMsg : msg,
                   showErrorMsg : true
               };
       }, () =>  {
           
       })
        setTimeout(() => { 
          
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       errorMsg : null,
                       showErrorMsg : false
                   };
           }, () =>  {
               
           })

        }, 5000)
      }
    
      doShowSuccessMsg ( msg) {
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   successMsg : msg,
                   showSuccessMsg : true
               };
       }, () =>  {
           
       })
        setTimeout(() => { 
          
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       successMsg : null,
                       showSuccessMsg : false
                   };
           }, () =>  {
               
           })

        }, 2000)
      }

    transormLinks(x) {
        var res = x.match( /\[link\]\s*(.+?)\s*\[\/link\]/g )
        var link;
        if (res != null) {
            for (var i = 0; i < res.length; i++) {
                console.log( res[i] )
                link = res[i].replace('[link]', '').replace('[/link]', '')
                x = x.replace(res[i], '<a target="_blank" href="'+ link +'">'+ link+'</a>')
                
            }
        }
        
        return x
    }
    rgbToHex(r, g, b) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
      }
      

    handleClickOutside(event) {
        if (this.colorPickerBtnColorRef && !this.colorPickerBtnColorRef.current.contains(event.target)) {
         
            this.setState({
            show_color_picker_btn_color: false
           })
        }
        if (this.colorPickerBg1ColorRef && !this.colorPickerBg1ColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_bg1_color: false
           })
        }
        if (this.colorPickerBg2ColorRef && !this.colorPickerBg2ColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_bg2_color: false
           })
        }
        
        
        if (this.colorPickerBtnTextColorRef && !this.colorPickerBtnTextColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_btn_text_color: false
           })
        }

        if (this.colorPickerH1ColorRef && !this.colorPickerH1ColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_h1_color: false
           })
        }
        if (this.colorPickerH2ColorRef && !this.colorPickerH2ColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_h2_color: false
           })
        }

        if (this.colorPickerLogoColorRef && !this.colorPickerLogoColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_logo_color: false
           })
        }

        if (this.colorPickerBgMobileColorRef && !this.colorPickerBgMobileColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_bg_mobile_color: false
           })
        }
      }
    componentWillMount() {
        this.setDefault()
        this.changeFrameView('desktop')
        document.addEventListener("mousedown", this.handleClickOutside);
        
        
        
        
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleChangeComplete = (color, a) => {
        
        //const decimalToHex = (alpha: number) => alpha === 0 ? '00' : Math.round(255 * alpha).toString(16)

        //const hexCode = `${color.hex}${decimalToHex(color.rgb.a)}` 
        var hexCode = color.rgb
         
        if (a == 'btn') {
            this.setState({ btn_color: hexCode, btn_color_hex:color.hex })
        }
        if (a == 'bg1') {
            //alert(color.rgb.a)
            this.setState({ bg1_color: hexCode, bg1_color_hex: color.hex, bg1_opacity:color.rgb.a})
        }
        if (a == 'bg2') {
            //alert(color.rgb.a)
            this.setState({ bg2_color: hexCode, bg2_color_hex: color.hex, bg2_opacity:color.rgb.a})
        }
        if (a == 'btnText') {
            //alert(color.rgb.a)
            this.setState({ btn_text_color: hexCode, btn_text_color_hex: color.hex })
        }
        if (a == 'h1') {
            //alert(color.rgb.a)
            this.setState({ h1_color: hexCode, h1_color_hex: color.hex })
        }
        if (a == 'h2') {
            //alert(color.rgb.a)
            this.setState({ h2_color: hexCode, h2_color_hex: color.hex })
        }
        if (a == 'logo') {
            //alert(color.rgb.a)
            this.setState({ logo_color: hexCode, logo_color_hex: color.hex })
        }
        if (a == 'bgMobile') {
            //alert(color.rgb.a)
            this.setState({ 
                bg_mobile_opacity: color.rgb.a,
                bg_mobile_color: hexCode, 
                bg_mobile_color_hex: color.hex })
        }
       
      }
    doSave(e) {
    e.preventDefault();
    
    const cookies = new Cookies();
    const arr = this.state;
    
    this.setState({
        isLoading: true
    });
    
    console.log('Sending data:', JSON.stringify(arr));
    
    axios.post(
        process.env.REACT_APP_BACKEND_SERVER + '/CreateTgWidget/', 
        {
            'data': JSON.stringify(arr)
        }, 
        {
            headers: {
                'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
            }
        }
    )
    .then(res => {
        this.setState({
            isLoading: false
        });
        
        console.log('Response:', res.data);
        
        if (res.data.status === 'ok') {
            window.location.href = '/widgetimplementation/' + res.data.alias;
        } else {
            // Любой другой статус - это ошибка
            const errorText = res.data.text || 'Произошла неизвестная ошибка';
            this.doShowErrorMsg(errorText);
        }
    })
    .catch(err => {
        console.error('Error:', err);
        this.setState({
            isLoading: false
        });
        
        let errorMessage = 'Произошла ошибка';
        
        if (err.response) {
            // Сервер ответил с ошибкой
            console.log('Error response:', err.response.data);
            
            if (err.response.data && err.response.data.text) {
                errorMessage = err.response.data.text;
            } else if (err.response.data && typeof err.response.data === 'string') {
                errorMessage = err.response.data;
            } else if (err.response.status === 403) {
                errorMessage = 'Доступ запрещён. Возможно, тариф закончился';
            } else if (err.response.status === 400) {
                errorMessage = 'Неверные данные. Проверьте все поля';
            } else if (err.response.status === 500) {
                errorMessage = 'Ошибка сервера. Попробуйте позже';
            } else {
                errorMessage = `Ошибка ${err.response.status}`;
            }
        } else if (err.request) {
            errorMessage = 'Нет связи с сервером. Проверьте интернет';
        } else {
            errorMessage = err.message || 'Неизвестная ошибка';
        }
        
        this.doShowErrorMsg(errorMessage);
    });
}
    updatePrize(e) {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    prize : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })


    }

    updateHeader (e) {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    header_text : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    }

    updateWidgetNameVk(e) {

        const cookies = new Cookies();
        cookies.set('widgetNameVk', e.target.value, {path : '/'})

        
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   widget_name : e.target.value,
                   
               
               };
       }, () =>  {
           
       })

        console.log(cookies.get('widgetNameVk'))
    }

    updateMain(e) {
        const updatedInputValue = e.target.value;
        
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    main_text : updatedInputValue,
                    
                
                };
        }, () =>  {
            
        })
    }

    handleClickZeroStage = (e) => {
        e.preventDefault()
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   showTgNameChannelPage : false
                   
               
               };
       }, () =>  {
           
       })
        setTimeout(() => {
          
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       showFirstStage : true
                       
                   
                   };
           }, () =>  {
               
           })

        }, 460)
        //setShowFisrtStage(true)
      }



      handleClickFirstStage = (e) => {
        e.preventDefault()
        //alert(1)
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   showFirstStage : false
                   
               
               };
       }, () =>  {})
        setTimeout(() => {
          
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       showSecondStage : true
                       
                   
                   };
           }, () =>  {
               
           })

        }, 460)
        //setShowFisrtStage(true)
      }


    handleClickSecondStage = (e) => {
        e.preventDefault()
        //alert(1)
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   showSecondStage : false
                   
               
               };
       }, () =>  {
           
       })
        setTimeout(() => {
          
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       showThirdStage : true
                       
                   
                   };
           }, () =>  {
               
           })

        }, 460)
        //setShowFisrtStage(true)
      }

    changeSocialNetwork(a) {

        
        if (a == 'tg') {
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       socialNetwork : a,
                       stage: '20_tg',
                       stageNum: this.stageNumTg
                       
                   
                   };
           }, () =>  {
               
           })
        }
        else {
            this.setState((prevState) => {
                return  {
                    ...prevState,
                    socialNetwork : a,
                    stage: '25_vk',
                    stageNum: this.stageNumVk
                    
                
                };
        }, () =>  {
            
        })
        }
        


    }

    updateTimeout(e) {

        this.setState((prevState) => {
            return  {
                   ...prevState,
                   timeout : e.target.value
                   
               
               };
       }, () =>  {
           
       })


    }


    updateBotToken(e) {

        this.setState((prevState) => {
            return  {
                   ...prevState,
                   bot_token : e.target.value
                   
               
               };
       }, () =>  {
           
       })


    }


    stageList = {
        '20_tg' : 'chooseSocialNetworkPage',
        '40_tg' : 'showTgBotTokenPage',
        '60_tg': 'showTgNameChannelPage',
        '80_tg': 'showFirstStage',
        '100_tg':  'showSecondStage',
        '25_vk' : 'chooseSocialNetworkPage',
        '50_vk' : 'showVkAuthPage'
    }
    
    stageListInfoBlock = {
       // '40_tg' : <span>Гайд: как создать Телеграм бота: <a href='https://telegra.ph/sdfsdgfg'>https://telegra.ph/sdfsdgfg</a></span>,
       // '100_tg' : <span>Гайд: как создать Телеграм бота: <a href='https://telegra.ph/sdfsdgfg'>https://telegra.ph/sdfsdgfg</a></span>,
        
       // '50_vk' : <span>Гайд:  как работает привязка вк <a href='https://telegra.ph/sdfsdgfg'>https://telegra.ph/sdfsdgfg</a></span>,
    }

    stageNumTg = 5
    stageNumVk = 4

    goBack(e) {
        e.preventDefault()
        
         if (this.state.socialNetwork == 'tg') {

            var percStep = Math.floor(100 / this.stageNumTg)
            if ( parseInt(this.state.stage.split('_')[0]) == percStep) {
                return
            }
            // this.state.socialNetwork
            //alert(this.stageList[this.state.stage ])
            var stageNow = this.state.stage
            var stagePrev = parseInt(this.state.stage.split('_')[0]) - percStep + '_'+this.state.socialNetwork
            
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       [this.stageList[stageNow]] : false,
                       [this.stageList[stagePrev]] : true,
                       infoBlock: [this.stageListInfoBlock[stagePrev]] ,
                       stage: stagePrev
                   
                   };
           }, () =>  {
               
           }) 

         }
         else {
            var percStep = Math.floor(100 / this.stageNumVk)
            if ( parseInt(this.state.stage.split('_')[0]) == percStep) {
                return
            }
            // this.state.socialNetwork
            //alert(this.stageList[this.state.stage ])
            var stageNow = this.state.stage
            var stagePrev = parseInt(this.state.stage.split('_')[0]) - percStep + '_'+this.state.socialNetwork
            
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       [this.stageList[stageNow]] : false,
                       [this.stageList[stagePrev]] : true,
                       infoBlock: [this.stageListInfoBlock[stagePrev]] ,
                       stage: stagePrev
                   
                   };
           }, () =>  {
               
           }) 
         }
      
        
    }

    goFurther() {
        
    //alert(123)
        if (this.state.socialNetwork == 'tg') {

            var percStep = 100 / this.stageNumTg
            var stageNow = this.state.stage
            var stageNext = parseInt(this.state.stage.split('_')[0]) + percStep + '_'+this.state.socialNetwork
           
            //alert( stageNext )
                   
            this.setState((prevState) => {
                    return  {
                        ...prevState,
                        stageNum :this.stageNumTg ,
                        [this.stageList[stageNow]] : false,
                        
                    
                    };
            }, () =>  {
                
            }) 
            //alert(this.stageList[stageNext])
            setTimeout(() => {
                    if (parseInt(this.state.stage.split('_')[0]) + percStep == 100) {
                        this.setState((prevState) => {
                            return  {
                                ...prevState,
                                stageNum :this.stageNumTg ,
                                showProgressNum: false,
                                [this.stageList[stageNext]] : true,
                                infoBlock: [this.stageListInfoBlock[stageNext]], 
                                stage :  stageNext
                            
                            };
                        }, () =>  {
                            
                        })
                    }
                    else {
                        this.setState((prevState) => {
                            return  {
                                ...prevState,
                                stageNum :this.stageNumTg ,
                                [this.stageList[stageNext]] : true,
                                stage :  stageNext,
                                infoBlock: [this.stageListInfoBlock[stageNext]], 
                            
                            };
                        }, () =>  {
                            
                        })
                    }
                
    
            }, 460)

        }
        else {
            alert('ВК доступен только на платных тарифах')
            return
            var percStep = 100 / this.stageNumVk
            var stageNow = this.state.stage
            var stageNext = parseInt(this.state.stage.split('_')[0]) + percStep + '_'+this.state.socialNetwork
           
            //alert( stageNext )
                   
            this.setState((prevState) => {
                    return  {
                        ...prevState,
                        stageNum :this.stageNumVk ,
                        [this.stageList[stageNow]] : false,
                        
                    
                    };
            }, () =>  {
                
            }) 
            //alert(this.stageList[stageNext])
            setTimeout(() => {
                    if (parseInt(this.state.stage.split('_')[0]) + percStep == 100) {
                        this.setState((prevState) => {
                            return  {
                                ...prevState,
                                stageNum :this.stageNumVk ,
                                showProgressNum: false,
                                [this.stageList[stageNext]] : true,
                                infoBlock: [this.stageListInfoBlock[stageNext]], 
                                stage :  stageNext
                            
                            };
                        }, () =>  {
                            
                        })
                    }
                    else {
                        this.setState((prevState) => {
                            return  {
                                ...prevState,
                                stageNum :this.stageNumVk ,
                                [this.stageList[stageNext]] : true,
                                stage :  stageNext,
                                infoBlock: [this.stageListInfoBlock[stageNext]], 
                            
                            };
                        }, () =>  {
                            
                        })
                    }
                
    
            }, 460)

        }
       

        
        
        
    }

    ChooseSocialNetwork(e) {
        
        
        e.preventDefault()
        //alert(1)
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   chooseSocialNetworkPage : false
                   
               
               };
       }, () =>  {
           
       })

       if (this.state.socialNetwork == 'tg') {

            setTimeout(() => {
            
                this.setState((prevState) => {
                    return  {
                        ...prevState,
                        showTgBotTokenPage : true,
                        stage : 40
                    
                    };
            }, () =>  {
                
            })

            }, 460)

            

       }
       else {
        setTimeout(() => {
            
            this.setState((prevState) => {
                return  {
                    ...prevState,
                    showVkAuthPage : true
                    
                
                };
        }, () =>  {
            
        })

        }, 460)

    
    }
    
    } 
    

    verifyBot() {
        const cookies = new Cookies();
        this.setState({
            isLoading: true
        })
        axios.get(process.env.REACT_APP_BACKEND_SERVER + '/verifyBotToken?token='+this.state.bot_token, {
            headers: {
                'Authorization': 'Bearer '+cookies.get('tgsubs_token')
            },
            
        }).then((res) => {
            console.log(res.data)
            this.setState({
                isLoading: false
            })
            if (res.data.verified) {
                this.doShowSuccessMsg('Бот подключен');
                this.setState((prevState) => {
                    return  {
                        ...prevState,
                        
                        
                        isLoading: false
                        
                    
                    };
                }, () =>  {
                    
                })
                this.goFurther()

            }
            else {
              
                this.doShowErrorMsg('неправильный токен')                                
           }
        })
        .catch(err => {
            console.log(err)
            alert('error')
            this.setState({
                isLoading: false
            })
            })
    }
    
    render() {
        return (
            <div>
                <Fade show={this.state.showErrorMsg}>
                <div className='errorMessage'>
                  Ошибка: {this.state.errorMsg}
                </div>
              </Fade>
              <Fade show={this.state.showSuccessMsg}>
                <div className='successMessage'>
                   {this.state.successMsg}
                </div>
              </Fade>
                <Loader loader={this.state.isLoading} />
                <div className='createPage'>
                        <div className="createPageTitle">
                            <h1 style={{marginBottom:"2px"}}> { this.props.title ? this.props.title : "Создать чат-бот+виджет"}</h1>
                            <HorizontalLine />
                        </div>
                        {this.state.infoBlock != '' ?<div className="helpBLockVertical helpBlock helpBlockCreateWidget"> <HelpBlockIcon /> {this.state.infoBlock}</div> : null}
                       
                        <div className='createWidgetMainBlock'>
                            <div className="createWidgetMainBlock__progressBar">
                                <div className="createWidgetMainBlock__progressBar_label">
                                    Этап:
                                </div>
                                
                               <LineProgressBar
                                   transition={{ easing: 'linear' }}
                                label={(value) => <div>  <span className={this.state.showProgressNum ? "progressBar_etaps" : "progressBar_etaps hidden"}><span className='progressBar_etaps_blue'>{value * this.state.stageNum / 100}</span>   /   {this.state.stageNum} </span> </div>} 
                                percent={parseInt(this.state.stage.split('_')[0])}
                                rounded={36}
                                height={'2.4em'}
                                progressColor="linear-gradient(90deg, #31D0E1 3.43%, #0868F5 86.29%);"
                                containerColor="#FFF" />`
                            </div>
                            
                          <div onClick={this.goBack} className="createWidgetMainBlock_back">< LeftArrowIcon /> Назад</div> 
                <Fade show={this.state.chooseSocialNetworkPage}>
                    
                    
                        
                        
                        <CreateWidgetChooseSocialNetwork
                        goFurther={this.goFurther} 
                        changeSocialNetwork={this.changeSocialNetwork}
                        socialNetwork={this.state.socialNetwork} />
                        
                    
                </Fade>
                <Fade show={this.state.showVkAuthPage}>
                <VkAuthPage 
                updateChannelName={this.updateChannelName} 
                updateWidgetNameVk={this.updateWidgetNameVk}
                 data={this.state}
                  handleClick={this.handleClickZeroStage}/>
                </Fade>  

                <Fade show={this.state.showTgBotTokenPage}>
                    <TgbotTokenPage 
                    verifyBot={this.verifyBot}
                     doShowErrorMsg={this.doShowErrorMsg} 
                     updateBotToken={this.updateBotToken}
                      bot_token={this.state.bot_token}/>
                </Fade> 


                <Fade show={this.state.showTgNameChannelPage}>
                <CreateWidgetNameChannel 
                updateChannelName={this.updateChannelName} 
                updatePageName={this.updatePageName}
                 data={this.state}
                 goFurther={this.goFurther}/>
                </Fade>  
                
                <Fade show={this.state.showFirstStage}>
                <CreatePageTelegramIntegration
                
                goFurther={this.goFurther}
                doShowErrorMsg={this.doShowErrorMsg} 
                CheckIntegration={this.CheckIntegration} 
                handleClick={this.handleClickFirstStage}
                showErrorMsg={this.state.showErrorMsg}
                errorMsg={this.state.errorMsg}
                />
                </Fade>  


               {/*
               <Fade show={this.state.showSecondStage}>
                <CreatePageChooseTmp  ChooseTemplate={this.ChooseTemplate} />
                </Fade>
               */}   
    
                
                
                <Fade show={this.state.showWidgetImplementionPage}>
                   <TgWidgetImplementationPage scriptsText={this.state.scriptsText} />
                </Fade> 
                </div>
                    
                <Fade show={this.state.showSecondStage}>
                <div style={{'marginTop':'13em'}}>
                <CreatePageInputs
                bg_mobile_opacity={this.state.bg_mobile_opacity} 
                colorPickerBgMobileColorRef={this.colorPickerBgMobileColorRef}                
                show_color_picker_bg_mobile_color={this.state.show_color_picker_bg_mobile_color}
                bg_mobile_color={this.state.bg_mobile_color}
                bg_mobile_color_hex={this.state.bg_mobile_color_hex}
                frame_view_type={this.state.frame_view_type}
                changeFrameView={this.changeFrameView}
                frame_height={this.state.frame_height}
                frame_width={this.state.frame_width}
                showColorPicker={this.showColorPicker}
                bg2_opacity={this.state.bg2_opacity} 
                initialContent={this.initialContent}
                bg2_color_hex={this.state.bg2_color_hex}
                bg1_color_hex={this.state.bg1_color_hex}
                bg1_opacity={this.state.bg1_opacity}
                btn_color_hex={this.state.btn_color_hex}
                refFirstStage={this.refFirstStage}
                h1_color_hex={this.state.h1_color_hex}
                h1_color={this.state.h1_color}
                h2_color_hex={this.state.h2_color_hex}
                logo_color_hex={this.state.logo_color_hex}
                btn_text_color_hex={this.state.btn_text_color_hex}
                setDefault={this.setDefault}
                colorPickerBtnColorRef={this.colorPickerBtnColorRef}
                show_color_picker_btn_color={this.state.show_color_picker_btn_color}
                btn_color={this.state.btn_color}
                handleChangeComplete={this.handleChangeComplete}
                colorPickerBg1ColorRef={this.colorPickerBg1ColorRef}
                show_color_picker_bg1_color={this.state.show_color_picker_bg1_color}
                bg1_color={this.state.bg1_color}
                colorPickerBg2ColorRef={this.colorPickerBg2ColorRef}
                show_color_picker_bg2_color={this.state.show_color_picker_bg2_color}
                bg2_color={this.state.bg2_color}
                colorPickerBtnTextColorRef={this.colorPickerBtnTextColorRef}
                show_color_picker_btn_text_color = {this.state.show_color_picker_btn_text_color}
                btn_text_color={this.state.btn_text_color}
                colorPickerH1ColorRef={this.colorPickerH1ColorRef}
                show_color_picker_h1_color={this.state.show_color_picker_h1_color}
                colorPickerH2ColorRef={this.colorPickerH2ColorRef}
                show_color_picker_h2_color={this.state.show_color_picker_h2_color}
                h2_color={this.state.h2_color}
                colorPickerLogoColorRef={this.colorPickerLogoColorRef}
                show_color_picker_logo_color={this.state.show_color_picker_logo_color}
                logo_color={this.state.logo_color} 



















                ClearPhotoMobile={this.ClearPhotoMobile}
                channel_name={this.state.channel_name}
                transormLinks={this.transormLinks}
                setShowPreview={this.setShowPreview}
                showPreview={this.state.showPreview}
                doSave={this.doSave}
                prize={this.state.prize}
                updatePrize={this.updatePrize}
                
                header_text={this.state.header_text}
                updateHeader={this.updateHeader}

                main_text={this.state.main_text}
                updateMain={this.updateMain}

                timeout={this.state.timeout}
                updateTimeout={this.updateTimeout}

                btnText={this.state.btnText}
                handleInputChange_bigImg={this.handleInputChange_bigImg}
                handleInputChange_smallImg={this.handleInputChange_smallImg}
                big_img_src={this.state.big_img_src}
                small_img_src={this.state.small_img_src}
                 />
                </div>
                
    
                </Fade> 
                    {this.state.infoBlock != '' ?<div className="helpBLockHorizontal helpBlock helpBlockCreateWidget"> <HelpBlockIcon /> {this.state.infoBlock}</div> : null}
         
                </div>

                
            </div>
                 
        )
    }
}